import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';

export class TermDelete {
  private term: APTerm;
  private popupClosed: () => void;
  private isOpened: boolean = true;

  constructor(
    private deleteTermCommand: ICommand,
    private phxFocusDelegate: any,
    private phxAxReturnFocusFactory: any,
    private ngAPNotificationDelegate: INotificationDelegate,
    private phxAxTitleAnnouncerDelegate: any
  ) {}

  $onInit() {
    this.isOpened = true;
  }
  accept() {
    this.closeDialog();
    this.deleteTermCommand(this.term)
      .then(() => {
        this.phxAxTitleAnnouncerDelegate.announceChange(`${this.term.name} term removed`);
        this.ngAPNotificationDelegate.success(`${this.term.name} term is deleted successfully.`);
      })
      .catch((e) => this.ngAPNotificationDelegate.error(`Failed to delete ${this.term.name} term.`));
  }

  openedChanged(event: CustomEvent) {
    if (_4.isFunction(this.popupClosed) && !_4.get(event, 'detail.value', true)) {
      this.popupClosed();
    }
  }

  closeDialog() {
    this.isOpened = false;
  }
}
angular.module('capability-ng-academic-planner').component('termDeleteModal', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/term_delete/term_delete.html',
  bindings: {
    term: '<',
    popupClosed: '&'
  },
  controller: TermDelete
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_delete/term_delete.ts